const routingZonesModel = vm => ({
  title: vm.$gettext('Routing Zones'),
  endpoint: 'routing-zones',
  allowNew: true,
  countrize: 'country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'code',
      label: vm.$gettext('Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Code to show in labels (max. 8 chars)')
    },
    {
      key: 'country_iso_code',
      label: vm.$gettext('Country ISO Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country (2 letter ISO code)')
    },
    {
      key: 'area',
      label: vm.$gettext('Area'),
      editable: false
    }
  ],
  filters: ['id', 'name', 'code', 'country_iso_code'],
  exclude: ['area']
})

export default routingZonesModel
